import $ from "jquery";


function Footer() {
    document.addEventListener("DOMContentLoaded", this._init.bind(this));
}

Footer.prototype._init = function () {
    var $form = $('.contact-form');
    $('.contact-form__button').on('click',function (e) {
        e.preventDefault();
        $form.toggleClass('cover-is-hidden');
        setTimeout(function () {
            $form.toggleClass('cover-is-at-back');
        },300)
    });
};


module.exports = new Footer();


// WEBPACK FOOTER //
// ./source/assets/scripts/footer.js